<template>
  <div>
    <div class="header-container">
      <div class="container">
        <div class="row">
          <header class="header">
            <nav class="site-nav navbar">
              <div class="container">
                <div class="row brand-section">
                  <!-- brand section -->

                  <div class="container">
                    <div class="col-12">
                      <div class="hamburger-menu">
                        <div class="row">
                          <div class="d-md-none hamburger-menu-item">
                            <button
                              class="navbar-toggler"
                              type="button"
                              data-toggle="collapse"
                              v-on:click="toggleNavbar"
                            >
                              <i class="fa fa-bars fa-lg py-1"></i>
                            </button>
                          </div>
                          <div class="d-md-none">
                            <a href="/" class="navbar-brand">
                              <span class="logo">
                                <img :src="image" title="Trinity Chapel" alt="Trinity Chapel" />
                              </span>
                            </a>
                          </div>
                        </div>

                        <div class="d-none d-md-block">
                          <div class="row">
                            <div class="col-3 col-md-2">
                              <div class="hamburger-menu-item">
                                <a href="/reservation/" class="navbar-brand">
                                  <span class="logo">
                                    <img :src="image" title="Trinity Chapel" alt="Trinity Chapel" />
                                  </span>
                                </a>
                              </div>
                            </div>
                            <div class="col-9 col-md-10">
                              <div class="row">
                                <div class="col-12 text-right clear-padding-left no-gutters">
                                  <ul class="utility-nav">
                                    <li class="nav-item d-none d-md-block"
                                      v-if="this.isAuthenticated" >
                                      <div class="welcome-text">
                                        <span class>welcome back, {{this.currentUser.name}}</span>
                                      </div>
                                    </li>

                                    <li class="nav-item">
                                      <router-link :to="this.isAuthenticated && this.currentUser.isAdmin ? '/admin' : '/my-account'"
                                        class="nav-link" >
                                        <!-- <i class="far fa-user" v-bind:class="[this.isAuthenticated ? 'logged-in-color' : '']"
                                          aria-hidden="true" ></i> -->
                                        <div v-if="this.isAuthenticated"><i class="far fa-user logged-in-color"
                                          aria-hidden="true"></i><span class="user-icon-text">My account</span>
                                        </div>
                                        <div  v-else>
                                          <i class="far fa-user"
                                            aria-hidden="true" ></i><span class="user-icon-text">Login or register</span>
                                        </div>

                                      </router-link>
                                    </li>
                                    
                                  </ul>
                                </div>
                                <div class="col-12 main-nav">
                                  <ul class="menu">
                                    <li class="nav-item"
                                      v-bind:class="[isActive('/') ? 'active' : '']">
                                      <router-link to="/" class="nav-link">Home</router-link>
                                    </li>
                                    <!--<li class="nav-item"
                                      v-bind:class="[isActive('/services') ? 'active' : '']">
                                      <router-link to="/services" class="nav-link">Services</router-link>
                                    </li>-->
                                    <li
                                      class="nav-item"
                                      v-bind:class="[isActive('/contact-us') ? 'active' : '']">
                                      <router-link to="/contact-us" class="nav-link">Contact us</router-link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mobile-side-nav">
                <!-- main nav -->

                <div class="col-12">
                  <div class="d-md-none">
                    <div class="menu-container">
                      <div
                        class="mobile-menu"
                        :class="[this.show ? 'mobile-menu-show' : 'mobile-menu-hide']">
                        <a class="navbar-toggler-close" v-on:click="toggleNavbar">
                          <i class="fa fa-times-circle fa-lg py-1"></i>
                        </a>
                        <div class="mobile-list">
                          <div class="welcome-text mobile-list-item" v-if="this.isAuthenticated">
                            <span class>welcome back, {{this.currentUser.name}}</span>
                          </div>

                          <div class="mobile-list-item">
                            <router-link
                              :to="this.isAuthenticated && this.currentUser.isAdmin ? '/admin' : '/my-account'"
                              class="nav-link nav-item">
                              <!-- <i class="far fa-user" v-bind:class="[this.isAuthenticated ? 'logged-in-color' : '']"
                                aria-hidden="true" ></i> -->
                                <div v-if="this.isAuthenticated"><i class="far fa-user logged-in-color"
                                  aria-hidden="true"></i><span class="user-icon-text">My account</span>
                                </div>
                                <div  v-else>
                                  <i class="far fa-user"
                                    aria-hidden="true" ></i><span class="user-icon-text">Login or register</span>
                                </div>
                                
                                
                            </router-link>
                          </div>

                          <ul class="side-nav-menu mobile-list-item">
                            <!-- <li class="">
                            
                            </li>-->
                            <li class="nav-item active">
                              <router-link to="/" class="nav-link">Home</router-link>
                            </li>
                            <!--<li class="nav-item active">
                            <router-link to="/services" class="nav-link">Services</router-link>
                            </li>-->
                            <li class="nav-item">
                              <router-link to="/contact-us" class="nav-link">Contact us</router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>
          </header>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { authMethods, authComputed, authMutations } from "@/state/helpers";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      show: false,
      image: require("@/assets/logo.png")
    };
  },
  computed: {
    ...authComputed,
    name() {
      return this.data;
    }
  },
  methods: {
    closeMenu(event) {},
    isActive(path) {
      var routePath = this.$route.path;
      return routePath === path;
    },
    toggleNavbar() {
      this.show = !this.show;
    }
  },
  watch: {
    $route() {
      this.show = false;
    }
  }
};
</script>

<style >
.header {
  width: 100%;
  margin-top: 0px;
  margin-bottom: 20px;
  /* overflow: hidden; */
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  /* position: relative; */
  /* border-bottom: 1px solid #d1d1d1; */
}
.hamburger-menu {
  padding: 2px 12px 2px 0;
}
.hamburger-menu-item {
  display: inline-block;
}
.menu {
  position: relative;
  display: block;
  margin: auto;
  padding: 0;
  list-style: none;
  text-align: left; /*center */
  width: 100%;
  z-index: 200;
  margin-bottom: 0px;
}
.main-menu-container {
  /* border: none; */
  border-top: 1px solid #d1d1d1;
}
.main-menu-container .container {
  padding-left: 0;
}
.menu-container {
  border: none;
}
.menu li {
  display: inline-block;
  padding: 4px;
  letter-spacing: 1px;
}
/* .menu li:first-child {
  padding-left: 0;
}
.menu li.nav-item:first-child a.nav-link {
  padding-left: 0;
} */
.menu li a {
  color: #1937a7;
  font-size: 0.9em;
  font-weight: 600;
  transition: color 200ms linear;
}
.menu li a:hover {
  color: #333;
}

.menu li.active {
  font-weight: 600;
}
.menu li.active a {
  color: #000;
}
.site-nav {
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #d1d1d1;
}
.site-nav .container {
  padding-left: 0;
  /* max-width: 100%; */
}
span.logo {
  padding: 0;
}
span.logo img {
  width: 100%;
  height: auto;
}
a.navbar-brand {
  width: 70px;
  background: #fff;
  margin-left: 0px;
}
.navbar-brand-container {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
}
.main-nav {
  margin-top: 10px;
  /* border-top: 1px solid #d1d1d1; */
}
.nav-link {
  color: #000;
}
.utility-nav .nav-item .nav-link {
  display: block;
  padding: 0.1rem 0rem;
  color: #1937a7;
}
.utility-nav .nav-item a.nav-link:hover {
  color: #333333;
}
.mobile-side-nav {
  position: relative;
  /* height: 100%;
  width: 100%; */
}
.mobile-menu {
  width: 0;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
  overflow: hidden;
  background-color: #1937a7;
  opacity: 1;
  transition: 0.5s;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.mobile-menu .mobile-list {
  display: flex;
  flex-flow: column nowrap;
  position: relative;
  top: 50px;
}
.mobile-menu .mobile-list .mobile-list-item {
  flex-grow: 1;
}
.mobile-menu .mobile-list .welcome-text{
  font-size: 1em;
  color: #fff;
  padding: 1em;
}


.mobile-menu-show {
  transition: 0.5s;
  left: 0;
  width: 100%;
  opacity: 1;
}
.navbar-toggler {
  z-index: 400;
}

.navbar-toggler-close {
  position: absolute;
  top: 10px;
  right: 20px;
  color: #ffffff;

  cursor: pointer;
  /* width: 40px;
  height: 40px; */
}
.navbar-toggler-close i {
  color: #ffffff;

  /* border-radius: 50%; */
  padding: 5px;
  font-size: 1.7em;
}
.mobile-menu ul {
  list-style: none;
  margin: 10px 0 0 0;
  padding: 0;
  position: relative;
}
.mobile-menu .nav-item {
  width: 100%;
  border-top: 1px solid #3f55a5;
  border-bottom: 1px solid #08174e; /**/
  list-style: none;
  min-width: 300px;
}
.mobile-menu .nav-item a {
  display: block;
  padding: 1em;
  /* background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.65) 100%
  ); */
  color: #ffffff;
  font-size: 1.2em;
  text-decoration: none;
}
.mobile-menu .nav-item a:hover {
  color: #ffdc00;
}
.mobile-menu ul li {
  list-style: none;
}

.mobile-menu a.nav-link {
  font-size: 1em;
  color: #fff;
  padding: 1em;
}
.mobile-menu a.nav-link span {
  color: #fff;
}
.mobile-menu a.nav-link i {
  font-size: 1.5em;

}
.mobile-menu a.nav-link:hover {
  color: #ffdc00;
}

.user-icon-text{
  padding-left: 15px;
  font-size: 1em;
  /* font-family: "Open Sans", sans-serif; */
}

.logo-container {
  text-align: center;
  padding: 0;
  margin: 0;
  position: relative;
}
.utility-nav {
  list-style: none;
  display: flex;
  margin: 0 12px 0 0;
  padding: 2px 0 0 12px;
  float: right;
}
.utility-nav .icon {
  width: 22px;
}
.welcome-text {
  margin-top: 2px;
}
.welcome-text span {
  margin-left: 10px;
  font-size: 0.9em;
  position: relative;
  vertical-align: bottom;
  float: left;
  line-height: 25px;
  padding-right: 6px;
}
.utility-nav li {
  /* width: 22px; */
  height: 22px;
  margin: 0 8px;
  /* padding: 0 12px 0 12px; */
}
.utility-nav li i {
  font-size: 1.6em;
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.brand-section {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}
.small-4 {
  width: 33.33333%;
}

.side-nav-utility {
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
  top: 50px;
}
.side-nav-utility {
  margin: 0 6px 15px 0;
  padding: 2px 0 0 6px;
  background: #fff;
  margin-top: 20px;
}
.mobile-menu ul.side-nav-menu {
  position: relative;
  margin-top: 15px;
}
@media (max-width: 768px) {
  .site-title h1 {
    font-size: 1.3em;
  }
  .site-title .contact-details {
    font-size: 0.8em;
  }
  #main-nav .navbar-custom-menu-holder .menu li {
    height: 30px;
    line-height: 30px;
  }
  a.navbar-brand {
    width: 50px;
  }
  .utility-nav {
    margin: 0 6px 0 0;
    padding: 2px 0 0 6px;
  }
  .utility-nav li {
    margin: 0 6px;
    padding: 0 12px 0 12px;
  }
  i.logged-in-color {
    color: #c26744;
  }

  /* .side-nav-utility {
    background: #fff;
  }
  .side-nav-utility .utility-nav {
    margin: 0 6px 0 0;
    padding: 2px 0 0 6px;
  } */
}
</style>

